import { isEmpty, omit } from 'lodash';

import { SORT_BY_FOR_API } from 'hb-react/frontoffice/apps/NewsIndex/constants';
import { fetchNews } from 'hb-react/frontoffice/apps/NewsIndex/requests/fetchNews';
import objectToQuery from 'hb-react/shared/utils/objectToQuery';

import { type FetchFilters, type Filters, type Sort, type Tags } from './types';

const getFilters = (filters: Filters) =>
  filters
    ? objectToQuery(filters, {
        getKey: (key) => key,
      })
    : {};

const getSort = (sort: Sort) =>
  sort?.value ? SORT_BY_FOR_API[sort.value] : {};

const getTags = (tags: Tags) =>
  tags ? { category_ids: Object.values(tags) } : {};

export const makeFetchItems =
  (url: string, params: object = {}) =>
  ({
    fetchFilters,
    page,
    signal,
  }: {
    fetchFilters: FetchFilters;
    page: number;
    signal: AbortSignal;
  }) => {
    const showPinned =
      isEmpty(fetchFilters?.filters) && isEmpty(fetchFilters?.tags);

    return fetchNews(url, signal, {
      page,
      ...(showPinned
        ? params
        : omit(params, 'pinned_on_index_page', 'pinned_to_index_page')), // flagEvNewsRevamp: Remove pinned_on_index_page when flag is cleaned up
      ...getFilters(fetchFilters?.filters),
      ...getTags(fetchFilters?.tags),
      ...getSort(fetchFilters?.sort),
    });
  };
